/* ========================================================================
 * DOM-based Routing
 * Based on http://goo.gl/EUTi53 by Paul Irish
 *
 * Only fires on body classes that match. If a body class contains a dash,
 * replace the dash with an underscore when adding it to the object below.
 *
 * .noConflict()
 * The routing is enclosed within an anonymous function so that you can
 * always reference jQuery with $, even when in .noConflict() mode.
 * ======================================================================== */

(function($) {

  var qs = (function(a) {
      if (a === ""){
        return {};
      }
      var b = {};
      for (var i = 0; i < a.length; ++i)
      {
          var p=a[i].split('=', 2);
          if (p.length === 1){
            b[p[0]] = "";
          }else{
            b[p[0]] = decodeURIComponent(p[1].replace(/\+/g, " "));
          }
      }
      return b;
  })(window.location.search.substr(1).split('&'));

  // Use this variable to set up the common and page specific functions. If you
  // rename this variable, you will also need to rename the namespace below.
  var Sage = {
    // All pages
    'common': {
      init: function() {
        // JavaScript to be fired on all pages

        // matchHeight
        $(function() {
        	$('.matchHeight').matchHeight();
        });

        // masonry
        $('.masonry-grid').masonry({
          itemSelector: '.grid-item',
          horizontalOrder: true,
          percentPosition: false,
          gutter: 2
        });

        // isotope
        var $grid = $('.isotope-grid').isotope({
          itemSelector: '.grid-item',
          masonry: {
            columnWidth: 100,
            gutter: 2,
            horizontalOrder: true,
          },
          // sortBy: 'clickedFirst',
          getSortData: {
            clickedFirst: function( itemElem ) {
              var $item = $( itemElem );
               // expanded first, otherwise use index
              return $item.hasClass('is-expanded') ? -1 : $item.index();
            }
          }
        });

        $grid.on( 'click', '.grid-item', function() {
          // change size of item by toggling is-expanded class
          var $this = $(this);
          // toggle other expanded
          if ( !$this.hasClass('is-expanded') ) {
            $grid.find('.is-expanded').removeClass('is-expanded');
          }
          $this.toggleClass('is-expanded');
          // update sort data, sort, and layout
          $grid.isotope('updateSortData').isotope();
        });


        // Show modal if snorkel site has a gallery
        $('.gallery img').on('click', function(){
          $('#galleryModal').modal('show');
        });

        // toggle Badges
        $('#toggleBadges').change(function() {
          if(this.checked) {
            $('#collapseBadges').show(400);
          } else {
            $('#collapseBadges').hide(400);
          }
        });

        var offset;
        offset = 100;
        /* if(navigator.userAgent.match(/iPad/i) != null){
          offset = 120;
        }*/

        /*
        window.viewportUnitsBuggyfill.init();
        if (document.getElementById('patched-viewport')) {
          window.addEventListener('resize', viewportUnitsBuggyfill.refresh, true);
        }*/

        $('body').on("click", 'a[href*="#"]:not([href="#"],[data-slide="prev"],[data-slide="next"],[data-toggle="collapse"],[data-toggle="tab"],[href="#tab"])', function() {
          if (location.pathname.replace(/^\//,'') === this.pathname.replace(/^\//,'') && location.hostname === this.hostname) {
            var target = $(this.hash);
            target = (target.length ? target : $('[name=' + this.hash.slice(1) +']'));
            if (target.length) {
              $('html,body').animate({
                scrollTop: target.offset().top - offset
              }, 1000);
              $('.navbar-collapse.in').removeClass("in");
              return false;
            }
          }
        });

        $("#toolkit-link").click(function() {
          $('html,body').animate({
                scrollTop: $("#toolkit-container").offset().top - offset
              }, 1000);
        });

        $('[data-toggle="tooltip"]').tooltip();

        $('[data-toggle="popover"]').popover();

        $('a[data-toggle="listing-item"]').on('click', function(){
          $(this).closest('.listing-grid').find('.listing-item').removeClass('hidden');
          $(this).addClass('disabled');
          $(this).closest('.listing-grid').addClass('listing-grid-expanded');
        });

        $('.related-items .related-item:gt(2)').addClass('hidden');

        $('a[data-toggle="related-item"]').on('click', function(){
          $(this).closest('.content-block.related').find('.related-item').removeClass('hidden');
          $(this).addClass('disabled');
          $('.related-items .related-item:gt(2)').removeClass('hidden');
        });

        $('.expanding_text .collapse').on('show.bs.collapse', function (e) {
          $(this).siblings('.btn-text').text('Close');
        });

        $('.expanding_text .collapse').on('hide.bs.collapse', function (e) {
          $(this).siblings('.btn-text').text('More');
        });

        $('.webcam-container').each( function(){
          if(typeof(local.webcam) !== undefined){
            jwplayer.key = "eq+vpfD3MOSPXvt0sBzs6ayQOdzZLsh+DSI/ZVzfGcI=";
            var webcam_m3u8 = $(this).find("source").attr('src');
            var container_id = $(this).attr('id');

            jwplayer( container_id ).setup({
              file: webcam_m3u8,
              autostart: 'viewable',
              width: '100%',
              height: 400,
              aspectratio: '4:3',
              stretching: 'uniform'
            });
          }
        });

        $("a.show_bio").on("click", function(){
          if( $(this).is(':contains("close")') ){
            $(this).closest( ".person" ).find(".person-bio").addClass("sr-only");
            $(this).html('Read biography <i class="fa fa-caret-right" aria-hidden="true"></i>');
          }else{
            $(this).closest( ".person" ).find(".person-bio").removeClass("sr-only");
            $(this).html('close <i class="fa fa-caret-down" aria-hidden="true"></i>');
          }
        });

        $("#newsletter-subscribe").on("click", function(){
          var modal = $("#modal-popup");
          modal.find('.modal-dialog').removeClass('modal-lg').addClass('modal-sm');
          var newsletterHTML = '<form action="https://scottishwildlifetrust.us16.list-manage.com/subscribe/post?u=42a0aea949935add99e6f101c&amp;id=8f04cb376c" method="post" id="subForm" target="_blank">'+
            '<div class="row"><div class="form-group col-xs-6">' +
              '<label for="mce-FNAME" class="sr-only">First Name</label>' +
              '<input id="mce-FNAME" name="FNAME" type="text" class="form-control" placeholder="First name">' +
            '</div>' +
            '<div class="form-group col-xs-6">' +
              '<label for="mce-LNAME" class="sr-only">Name</label>' +
              '<input id="mce-LNAME" name="LNAME" type="text" class="form-control" placeholder="Last name">' +
            '</div></div>' +
            '<div class="form-group">' +
              '<label for="yourEmail" class="sr-only">Email address</label>' +
              '<input id="yourEmail" name="EMAIL" type="email" class="form-control" placeholder="and your email" required>' +
            '</div>' +
            '<button type="submit" class="btn btn-primary">Subscribe</button>' +
          '</form>';
          modal.find('.modal-title').text('Subscribe to our newsletter');
          modal.find('.modal-body').html(newsletterHTML);
        });

        $("#subForm").on( "submit", function(){
          var modal = $("#modal-popup");
          modal.find('.modal-dialog').removeClass('modal-sm');
          modal.find('.modal-title').text('');
          modal.find('.modal-body').html('');
          modal.modal('hide');
        });

        /*
        var parallax_header = $('.nav-primary-container .carousel .item,.nav-primary-container[style*="url("]');
        $(window).scroll( function () {
          var st = $(this).scrollTop();
          parallax_header.css({'background-position':'center calc(45% - '+(st*0.055)+'px)'});
        });
        */

        /**
         * Map variables are defined in extras.php and use "local" object
         */
        var polylines = [];
        var paths = [];
        var markers = [];
        var infoWindows = [];
        var map;
        var geocoder;

        function closeAllInfoWindows() {
          for (var i=0;i<infoWindows.length;i++) {
             infoWindows[i].close();
          }
        }
        /**
         * Data for markers consists of name, Lat, Lng, zIndex & icon for
         * order in which markers should stack;
         * data contained in local.map.markers and defined in extras.php
         * within localise_jsdata function
         */
        function setMarkers(map){
          if(typeof(local.map) !== 'undefined'){

            var bounds = new google.maps.LatLngBounds();

            if(typeof(local.map.polyline) !== 'undefined'){
              for (var i = local.map.polyline.length -1; i >= 0 ; i--) {
                var polylineMarker = local.map.polyline[i];
                var subjectId = polylineMarker[1];
                polylines[subjectId] = new google.maps.Polyline({
                   strokeColor: polylineMarker[2],
                   strokeOpacity: 0.4
                }); // create polyline (global)
                paths[subjectId] = []; // global var to hold locations
                markers[subjectId] = [];
              }

            }

            for (var j = local.map.markers.length-1; j >= 0; j--) {
              var mapMarker = local.map.markers[j];
              var markerPosition = new google.maps.LatLng(mapMarker[1], mapMarker[2]);
              var markerIcon = mapMarker[4];
              bounds.extend(markerPosition);

              if( !~ markerIcon.indexOf('http') ){
                markerIcon = {
                  path: google.maps.SymbolPath.CIRCLE,
                  fillColor: mapMarker[4],
                  fillOpacity: 0.75,
                  scale: 4.5,
                  strokeColor: 'white',
                  strokeWeight: 1
                };
              }
              var marker = new google.maps.Marker({
                position: markerPosition,
                map: map,
                title: mapMarker[0],
                zIndex: mapMarker[3],
                icon: markerIcon
              });
              if(mapMarker[8] && markerPosition){
                markers[mapMarker[8]].push(marker);
                paths[mapMarker[8]].push(markerPosition);
              }
              var infowindow = new google.maps.InfoWindow();
              infoWindows.push(infowindow);
              var content = '<p><strong>'+mapMarker[0]+'</strong>'+
              (mapMarker[5]?'<br>'+mapMarker[5].replace(/([^>\r\n]?)(\r\n|\n\r|\r|\n)/g, '$1' + '<br>' + '$2'):'')+'</p><p>'+
              (mapMarker[6]?'<a href="'+
              mapMarker[6]+'">Visit the '+mapMarker[0]+' page &raquo;</a>':'')+
              /*
              (mapMarker[7]?'<br><a href="#'+
              mapMarker[7]+'">More information &raquo;</a>':'')+
              */
              (mapMarker[9]?mapMarker[9]:'')+
              '</p>';
              google.maps.event.addListener(marker,'click', (function(marker,content,infowindow){
                return function() {
                  closeAllInfoWindows();
                  infowindow.setContent(content);
                  infowindow.open(map,marker);
                };
              })(marker,content,infowindow));
            }

            if(local.map.markers.length > 1){
              map.fitBounds(bounds);
            }

          }
        }
        var showMarkers = function(subjectId) {
          var subjectMarkers = markers[subjectId];
          polylines[subjectId].setMap(map);
          for (var i = subjectMarkers.length-1;  i >= 0; i--) {
            subjectMarkers[i].setMap(map);
          }
        };
        var hideMarkers = function(subjectId) {
          var subjectMarkers = markers[subjectId];
          polylines[subjectId].setMap(null);
          for (var i = subjectMarkers.length-1;  i >= 0; i--) {
            subjectMarkers[i].setMap(null);
          }
        };
        function geocodeAddress(geocoder, address) {
          geocoder.geocode({'address': address}, function(results, status) {
            if (status === 'OK') {
              map.setCenter(results[0].geometry.location);
              var locationMarker = new google.maps.Marker({
                map: map,
                position: results[0].geometry.location,
                title: address,
                zIndex: 999,
                icon: 'https://raw.githubusercontent.com/Concept211/Google-Maps-Markers/master/images/marker_green.png'
              });
              var miles = 10;
              var locationRadius = new google.maps.Circle({
                strokeColor: '#FF0000',
                strokeOpacity: 0.8,
                strokeWeight: 2,
                fillColor: '#ff69b4',
                fillOpacity: 0.1,
                map: map,
                center: results[0].geometry.location,
                radius: miles * 1609.344
              });
              map.fitBounds(locationRadius.getBounds());
              var target = $('#map');
              $('html,body').animate({
                scrollTop: target.offset().top - offset
              }, 1000);
              console.log('geocode successful');
            } else {
              alert('Geocode was not successful for the following reason: ' + status);
            }
          });
        }
        /* define mapDiv before initMap */
        var mapDiv = document.getElementById('map');
        var minZoomLevel = 5;
        /* define initMap on all pages */
        $(function initMap() {
          /* test if mapDiv exists before initialising map */
          if(mapDiv){
            map = new google.maps.Map(mapDiv, {
              center: {lat: (local.map.latitude === undefined ? 57 : local.map.latitude), lng: (local.map.longitude === undefined ? -4.35 : local.map.longitude)},
              zoom: (local.map.zoom === undefined ? 7 : parseInt(local.map.zoom)),
              scrollwheel: false,
              mapTypeId: (local.map.type === undefined ? 'terrain' : local.map.type)
            });
            geocoder = new google.maps.Geocoder();

            setMarkers(map);

            if(typeof(local.map.polyline) !== 'undefined'){
              if(local.map.polyline.length > 0){
                var polyline_count = local.map.polyline.length;
                for(var k=polyline_count-1; k>=0; k--){
                  var polylineMarker = local.map.polyline[k];
                  var subjectId = polylineMarker[1];
                  polylines[subjectId].setMap(map);
                  polylines[subjectId].setPath(paths[subjectId]);
                }
              }
            }

            var locationSearch = qs['location-search'];
            if(locationSearch){
              //console.log(locationSearch);
              geocodeAddress(geocoder, locationSearch);
            }

            var trackingDiv = $('#trackingSubject input[type=checkbox]');
            if(trackingDiv){

              $('#trackingSubject input[type=checkbox]').on("change",function(){
                if($(this).is(":checked")){
                  showMarkers($(this).val());
                }else{
                  hideMarkers($(this).val());
                }
              });
            }

          }
        });

        /* copy loaded carousel images into thumbnails */
        $('.carousel .show-thumbnails').each(function(i){

          var carouselId = $(this).find(".carousel").attr('id');

          var containerId = 'cthumbs-' + Math.floor((Math.random() * 100) + 1);
          var thumbnailContainer = $('<div class="carousel-thumbnails" id="cthumbs-'+
            containerId + '"></div>');
          thumbnailContainer.appendTo( $(this) );
          var dataIndex = 0;
          $(this).find(".carousel-inner div.item").each(function(i) {

            var item = $('<a data-gallery="gallery" href="#'+carouselId+'" data-index="'+
              dataIndex+'"></a>');
            var innerItem = $('<div class="thumbnail"></div>');
            var style = $(this).attr('style');

            innerItem.attr("style",style);
            innerItem.appendTo( item );
            item.appendTo( thumbnailContainer );
            dataIndex += 1;
          });
        });


        /* when clicking a thumbnail */
        $('.carousel-thumbnails a').click(function(e){
          var idx = $(this).data("index");
          console.log(idx);
          var id = parseInt(idx);
          $(this).parent().siblings(".carousel.slide").carousel(id); // slide carousel to selected
        });

        /* membership forms including main form and:
        'scottish_wildlife_trust_membership_jordans':
        'scottish_wildlife_trust_membership_stay_wild':
        'scottish-wildlife-trust-membership-30-days-wild':
        'scottish_wildlife_trust_membership_january_sale':*/

        if( $(".membership-for .gfield_radio input").length ){
          $(".membership-for").on("change", function(){

            // former standalone checkRecipient() function
            var membershipFor = $(".membership-for .gfield_radio input:checked").val();
            if(typeof(membershipFor) !== 'undefined'){
              if(membershipFor == 'For me'){
                $('.membership-payment-type input[value="direct-debit"]').removeAttr('disabled').prop('disabled',false);
                $('.membership-payment-type').show();
                $('.membership-payment-type input[value="direct-debit"]').click();
              }else{
                $('.membership-payment-type input[value="credit-card"]').click();
                $('.membership-payment-type').hide();
                $('.membership-payment-type input[value="direct-debit"]').attr('disabled',true).prop('disabled',true);
              }
            }

            $(".membership-amount").removeClass("gfield_error");
            $(".membership-amount .validation_message").remove();
          });
          //checkRecipient(); - firing again here causes user selection to change between form pages
        }

        if( $(".membership-type .gfield_radio input").length ){

          $(".gfield_html").each(function(){
            var image = $(this).find("figure img").attr("src");
            var matches;
            if(matches = this.className.match(/(?:\s+|^)membership-(\S+)-description(?:\s+|$)/)){
              $(".membership-type input[value="+matches[1]+"]").siblings("label").attr("style", "background-image:url("+image+")");
            }
          });

        }

      },
      finalize: function() {
        // JavaScript to be fired on all pages, after page specific JS is fired

        function postPaging(){
          var total_records = $( ".post-list" ).data( "records-total" );
          var shown_records = $( ".post-list article").length;
          if(total_records > shown_records){
            $('#pagination').show();
          }else{
            $('#pagination').hide();
          }
        }
        postPaging();

        function loadPostData(){
          var shown_records = $( ".post-list article").length;
          var records_per_page =  $( ".post-list" ).data( "records-page" );
          var new_link = (shown_records / records_per_page) + 1;
          var link = $(this).attr('href').slice(0, -1);
          var paths = link.split('/');
          paths[ paths.length-1 ] = new_link; // new value
          link = paths.join('/')+'/';

          $.get( link, function (data){
            $( data ).find( ".post-list article" ).appendTo( ".post-list" );
          }).done(function(data){postPaging();});
          return false;
        }

        $( '#pagination a' ).on( 'click', loadPostData );

        function loadBlogs(object){
          $( '#pagination a' ).off();
          var link = object.data("source");

          // pagination link
          var page_url = document.querySelector("link[rel='canonical']").href;
          $.get( link, function (data){
            var content = $( data ).find( ".post-list" ).contents();
            var totalRecords = $( data ).find( ".post-list" ).data( "records-total" );
            var pageRecords = $( data ).find( ".post-list" ).data( "records-page" );
            $(".block-blogs-list .post-list").html( content );
            $(".block-blogs-list .post-list").data("records-total", totalRecords);
            $(".block-blogs-list .post-list").data("records-page", pageRecords);
          }).done(function(data){
            link = link.replace(window.location.origin,'');
            page_url = page_url.replace(window.location.origin,'');

            var new_pagination_link = $("#pagination a").attr('href').replace( page_url, link );
            $("#pagination a").attr('href', new_pagination_link).on( 'click', loadPostData );
          });

        }

        if( $(".nav-blogs").length ){
          $( 'body' ).on( 'click', '.nav-blogs a[data-toggle="tab"]', function (e) {
            e.preventDefault();
            loadBlogs($(this));
          });
          var urlHash = window.location.hash;
          if(urlHash){
            var urlHashObj = $('.nav-blogs a[data-toggle="tab"][href="'+urlHash+'"');
            if(urlHashObj){
              urlHashObj.trigger( "click" );
              loadBlogs(urlHashObj);
            }
          }
        }

        $('a[data-toggle="tab"]').on('click', function () {
          var $this = $(this);
          $this.on('shown.bs.tab', function () {
            var grid = $('.ff-stream-wrapper').data('shuffle');
            if (grid){
              $(window).resize();
            }
          });
        });

        function keywordSearch(){
          var searchText = $('#post-filter').val().toLowerCase(),
              searchStringLength  = $('#post-filter').val().length;
          if(searchStringLength > 2){
            $('.post-item').each(function () {
              var keywordContent = $(this),
                  text  = $(this).text(),
                  textL = text.toLowerCase();

              if(textL.indexOf(searchText) !== -1){
                keywordContent.addClass("result").show();
              }else{
                keywordContent.removeClass("result").hide();
              }
              });
          }else{
            $(".post-item").addClass("result").show();
          }
          $('#post-count').text($('.post-item.result').length);
        }

        var timer = 0;

        $('#post-filter').on('keyup', function() {
          if (timer) {
            clearTimeout(timer);
          }
          timer = setTimeout(keywordSearch, 400);
        });

        $('#post-filter').val("");

        $('.product-addon-gift-aid').hide();
        $('body').on('change','.product-addon-additional-donation input',function(){
          if( parseFloat($(this).val()) >= 1){
            var donation = $(this).val();
            $(this).val( donation.toLocaleString('en-GB', { style: 'currency', currency: 'EUR' }));
            $('.product-addon-gift-aid').show();
          }else{
            $('.product-addon-gift-aid').hide();
          }
        });

        $('#navbar-apex .nav-login a, a.login-register').on('click', function(e){
          //e.preventDefault();
          //$('#modal-login').modal('show');
        });

        $('.panel-collapse').on('show.bs.collapse', function () {
          $(this).siblings('.panel-heading').addClass('active');
        });
        $('.panel-collapse').on('hide.bs.collapse', function () {
          $(this).siblings('.panel-heading').removeClass('active');
        });

        $('#modal-login').on('shown.bs.modal', function() {
          //window.um_recaptcha_refresh();
        });

        $('#login-accordion').on('shown.bs.collapse', function(e) {
          if ($(this).is(e.target)) {
            console.log(this.id);
            show_modal_recaptcha(this.id);
          }
        });

        function show_modal_recaptcha(id){
          var grecaptchaInstance = $(id).find('.g-recaptcha');
          grecaptchaInstance.empty();
          grecaptcha.reset(grecaptchaInstance.attr('id'));
          grecaptcha.render( id, {
            'sitekey': $(this).attr('data-sitekey'),
            'theme': $(this).attr('data-theme')
          });
        }

        $(".um-register .um-toggle-gdpr").on('click', function(){
          $(".um-register .um-gdpr-content").load( "privacy-notice/ #flexi-content" );
        });

        if($("#login-accordion .um.um-err").length){
          console.log('has length');
          //$('#modal-login').modal('show');
        }

        $("body").on('click',".btn-wishlist", function(e) {
          e.preventDefault();
          post_id = $(this).attr("data-id");
          nonce = $(this).attr("data-nonce");

          if($(this).hasClass('wishlist-add')){
            $(this).html('<i class="fas fa-spinner fa-pulse"></i> Adding to wishlist');
          }else{
            $(this).html('<i class="fas fa-spinner fa-pulse"></i> Removing from wishlist');
          }

          $.ajax({
            type : "post",
            dataType : "json",
            url : swtAjax.ajaxurl,
            data : {action: "user_wishlist", post_id : post_id, nonce: nonce},
            success: function(response) {
              if(response.status == "Added") {
                $('#wishlist-'+post_id).removeClass('wishlist-add').addClass('wishlist-remove').html('<i class="fas fa-heart fa-fw"></i> Remove from wishlist');
              }
              if(response.status == "Removed") {
                $('#wishlist-'+post_id).removeClass('wishlist-remove').addClass('wishlist-add').html('<i class="far fa-heart fa-fw"></i> Add to wishlist');
              }
            }
          });
        });

        $("body").on('click', ".btn-logbook", function(e){
          var postID = $(this).data('id');

          if(postID){
            var postTitle = $(this).closest('article').find('h3 a').text();
            if(postTitle.length < 1){
              var postTitle = $(this).closest('article').find('h2').text();
            }
            $('#logbookModal .acf-field[data-name="logbook_single_post_id"] input').val(postID);
            $('#logbookModalTitle').text('New logbook entry for '+postTitle);
            $('#logbookModal #acf-_post_title').val(postTitle);
          }
        });

        // init Isotope
        var $grid = $('.grid').isotope({
          // options
        });
        // filter items on button click
        $('.filter-button-group').on( 'click', 'button', function() {
          var filterValue = $(this).attr('data-filter');
          $grid.isotope({ filter: filterValue });
          $('.filter-button-group button').removeClass('btn-primary');
          $(this).addClass('btn-primary');
        });

        $("body").delegate(".datepicker", "focusin", function(){
            $(this).datepicker();
        });
      }
    },
    // Home page
    'home': {
      init: function() {
        // JavaScript to be fired on the home page
      },
      finalize: function() {
        // JavaScript to be fired on the home page, after the init JS
      }
    },
    // Tracking
    'osprey_tracking': {
      init: function() {
        // JavaScript to be fired on the page
      },
      finalize: function() {
        // JavaScript to be fired on the page, after the init JS
      }
    },
    'adoptions': {
      init: function() {
      },
      finalize: function() {
        // JavaScript to be fired on the page, after the init JS

        // JavaScript to be fired on the page

        //ecertificates
        /*$('body.postid-849213 .woocommerce-product-gallery__image--placeholder').append('<div id="certificate_name"></div>');

        $('body.postid-849213  #input_52_52').on('keyup', function(){
          var previewTitle = $(this).val();
          $('#certificate_name').text(previewTitle);
        });

        function direct_debit(){
          $('.adoption-payment-type input[value="credit-card"]').removeAttr('checked');
          $('.adoption-payment-type input[value="direct-debit"]').attr('checked', true).prop('checked', true);
          var payment_frequency = $('.adoption-dd-recurrence input:checked').val();
          $('.adoption-dd-recurrence').show();
          $('.credit-card-message').hide();
        }

        function hide_payment_type(){
          $('.adoption-payment-type').hide();
        }

        function toggle_payment_method(){
          var adoption_for = $('.adoption-for input:checked').val();

          if(adoption_for == 'For me'){
            direct_debit();
            hide_payment_type();
          }else{
            credit_card();
            hide_payment_type();
          }
        }
        */

        $('.adoption-for input').on('click', function(e){
          var adoption_for = $('.adoption-for input:checked').val();

          if(adoption_for == 'For me'){
            //$('.adoption-payment-type input[value="credit-card"]').parent().addClass('hidden');
            $('.adoption-payment-type input[value="direct-debit"]').parent().removeClass('hidden');
            $('.adoption-payment-type input[value="direct-debit"]').attr('checked', true).prop('checked', true);
            $('.credit-card-amount').hide();
          }else{
            credit_card();
            $('.adoption-payment-type input[value="direct-debit"]').parent().addClass('hidden');
          }
        });

        function credit_card(){
          $('.adoption-payment-type input[value="credit-card"]').parent().removeClass('hidden');
          $('.adoption-payment-type input[value="direct-debit"]').removeAttr('checked');
          $('.adoption-payment-type input[value="credit-card"]').attr('checked', true).prop('checked', true);
          // show minimum payment amount
          $('.adoption-dd-recurrence').hide();
          $('.credit-card-message').show();
          $('.monthly-dd-amount').hide();
          $('.annual-dd-amount').hide();
          $('.credit-card-amount').show();
          $('.credit-card-amount input').removeAttr('disabled');
        }

        $('#prefer-credit-card').on('click', function(e){
          e.preventDefault();
          credit_card();
        });

        //$('.adoption-payment-type input[value="credit-card"]').parent().addClass('hidden');

        $('.adoption-dd-recurrence input[value="dd-monthly"]').parent().addClass('hidden');

        $('.single_add_to_cart_button').text("Adopt Now");
      }
    },
    'scottish_wildlife_trust_donation':{
      init: function() {
        // JavaScript to be fired on the donation page
      },
      finalize: function() {
        // JavaScript to be fired on the donation page, after the init JS
        $(".donation-appeals .gfield_radio").append('<li style="display: none;"><label id="all-appeals">Show all appeals</label></li>');
        function hideAppeals(){
          $(".donation-appeals .gfield_radio input:checked").parent().siblings().hide();
          $("#all-appeals").parent().show();
        }
        function showAppeals(){
          $(".donation-appeals .gfield_radio li").show();
          $("#all-appeals").parent().hide();
        }
        $(".donation-appeals .gfield_radio input").on("click", function(){
          hideAppeals();
        });
        $("#all-appeals").on("click", function(){
          showAppeals();
        });

        if(qs['appeal']){
          hideAppeals();
        }

        $(".gfield_radio input").each(function(){
          var value = $(this).attr('value');
          if(typeof(value) !== 'undefined'){
            if(value.indexOf("|") > 0){
              var price = value.split("|").pop();
              $(this).siblings('label').prepend('<span class="h3">&pound;'+price+'</span><br>');
            }
          }
        });
        $(".gform_fields").on("focus", "input.ginput_amount", function(){
          $(".gfield_radio input").each(function(){
            var value = $(this).attr('value');
            if(typeof(value) !== 'undefined'){
              if(value.indexOf("|") > 0){
                $(this).prop('checked', false);
              }
            }
          });
        });

        $(".gfield_html").each(function(){
          var image = $(this).find("figure img").attr("src");
          var matches;
          if(matches = this.className.match(/(?:\s+|^)appeal-(\S+)-description(?:\s+|$)/)){
            $(".donation-appeals input[value="+matches[1]+"]").siblings("label").attr("style", "background-image:url("+image+")");
          }
        });
      }
    },
    'prodcat_membership':{
      init: function() {
        // JavaScript to be fired on the membership page
        $(".membership-type .gfield_radio").append('<li style="display: none;"><label id="all-memberships">Show all membership types</label></li>');
        function hideMemberships(){
          $(".membership-type .gfield_radio input:checked").parent().siblings().hide();
          $("#all-memberships").parent().show();
        }
        function showMemberships(){
          $(".membership-type .gfield_radio li").show();
          $("#all-memberships").parent().hide();
        }
        if($(".membership-type .gfield_radio input").prop("checked") === true){
          hideMemberships();
        }
        $(".membership-type .gfield_radio input").on("change, click", function(){
          hideMemberships();
        });
        $("#all-memberships").on("click", function(){
          showMemberships();
        });
      },
      finalize: function() {
        // JavaScript to be fired on the membership page, after the init JS

        $("body .gform_wrapper .membership-type").on("click", "input", function(){
          var directDebit = $(".membership-payment-type input[value='direct-debit']");
          var creditCard = $(".membership-payment-type input[value='credit-card']");
          var membershipFor = $(".membership-for .gfield_radio input:checked").val();

          if(typeof(membershipFor) !== 'undefined'){
            if(membershipFor == 'For me'){
              if($(this).val() == 'life' || $(this).val() == 'joint-life' || $(this).val() == 'world'){
                directDebit.attr('disabled',true);
                directDebit.parent().hide();
                setTimeout(function(){ creditCard.click(); }, 500);
              }else{
                directDebit.attr('disabled',false);
                directDebit.parent().show();
                setTimeout(function(){ directDebit.click(); }, 500);
              }
            }
          }

          if(typeof(membershipFor) !== 'undefined'){
            if(membershipFor == 'For me'){
              $('.membership-payment-type input[value="direct-debit"]').removeAttr('disabled').prop('disabled',false);
              $('.membership-payment-type').show();
              $('.membership-payment-type input[value="direct-debit"]').click();
            }else{
              $('.membership-payment-type input[value="credit-card"]').click();
              $('.membership-payment-type').hide();
              $('.membership-payment-type input[value="direct-debit"]').attr('disabled',true).prop('disabled',true);
            }
          }
        });

        function addTimeframe(){
          $('.membership-amount .ginput_container_product_price span').remove();
            if( ($('.membership-dd-recurrence input:checked').val() == "dd-monthly" &&
                  $('.membership-payment-type input:checked').val() == "direct-debit")
                || ($('.contribution-type').length &&
                  $('.contribution-type input:checked').val() != 'regular')
              ){
              $('.membership-amount .ginput_container_product_price').append('<span>/ month</span>');
              console.log('monthly');
            }else{
              if($(".membership-type input:checked").val() == 'life' ||
                $(".membership-type input:checked").val() == 'joint-life' ||
                $(".membership-type input:checked").val() == 'world' ||
                $(".membership-for input:checked").val() != 'For me' /*gift membership*/
                ){
                console.log('nothing');
                // append nothing
              }else{
                $('.membership-amount .ginput_container_product_price').append('<span>/ year</span>');
                console.log('annually');
              }
            }
        }
        $('body').on("change", ".membership-payment-type input,.membership-dd-recurrence input,.contribution-type input,.membership-for input", function(){
          addTimeframe();
        });
        addTimeframe();

        if($('.contribution-type').length){ // if contribution type exists
          $('.gform_page').on('change', '.contribution-type input', function(){
            if($(this).val() == 'oneoff'){
              $('.membership-payment-type input[value="direct-debit"]').prop('checked', false ).prop( 'disabled', true );
              $('.membership-payment-type input[value="credit-card"]').prop('checked', true);
              // show minimum payment amount
              $('.credit-card-message').removeClass('gfield_visibility_hidden').addClass('gfield_visibility_visible');
              $('.credit-card-message').show();
            }else{
              $('.membership-payment-type input[value="direct-debit"]').prop( "disabled", false );
            }
          })
        }

        function show_guardian_field(id, currentPrice){
          var classList = document.getElementById(id).className.split(/\s+/);
          var guardianTrigger = classList.filter(function(item){
            return typeof item == 'string' && item.indexOf("guardian-") > -1;
          });

          if(guardianTrigger[0]){
            var arrGuardianTrigger = guardianTrigger[0].split(/\-/);
            var guardianPrice = parseFloat(arrGuardianTrigger[1]);
            var currPrice = parseFloat(currentPrice.split('.').join(""));
            var tr = $("#"+id+" .noUi-connect").css('transform');
            var a, values;
            var values = tr.split('(')[1];

            if(values){
              values = values.split(')')[0];
              values = values.split(',');
              a = parseFloat(values[0]);
            }

            if(currPrice >= guardianPrice){
              $("#"+id+" .noUi-tooltip").addClass("bg-primary").attr("title", "Become a Wildlife Guardian");
              $(".gfield.wildlife-guardian").removeClass("hidden");
            }else{
              $("#"+id+" .noUi-tooltip").removeClass("bg-primary").attr("title", "");
              $(".gfield.wildlife-guardian").addClass("hidden");
            }

            if(a == 1){
              if(!$("#"+id+" .noUi-tooltip span").length){
                $("#"+id+" .noUi-tooltip").append('<span>+</span>');
              }
            }else{
              if($("#"+id+" .noUi-tooltip span").length){
                $("#"+id+" .noUi-tooltip span").remove();
              }
            }
          }
        }

        function calculate_slider_price(val){
          if(val > 0){
            $(".membership-amount input").val(val);
            $(".membership-amount input").attr('value',val);
            gformFormatPricingField($(".membership-amount input"));
            $(".hidden-total.gfield_total input").val(val);
          }
        }

        $("body .gform_wrapper").on("blur", ".membership-amount input", function(){
          // Set one handled slider
          var val = Number($(this).val().replace(/[^0-9.]/g,'')).toFixed(2);
          var slider = $(".membership-slider:visible input:enabled");
          var sliderId = slider.attr('id');
          document.getElementById(sliderId).value = val;
          document.getElementById(sliderId).dispatchEvent(new Event('change'));
          $(this).attr('value', val);
          $(this).val(val);
          gformFormatPricingField($(this));
          show_guardian_field(slider.closest('.gfield').attr('id'), val);
        });

        $("body .gform_wrapper").on("change", ".membership-payment-type input, .membership-dd-recurrence input, .membership-type input", function(e){
          setTimeout(function() {
            calculate_slider_price($(".membership-slider:visible input").val());
          }, 250);
        });

        $("body .gform_wrapper").on("change", ".membership-slider:visible input", function(e){
          var val = $(this).attr('value');

          if(val > 0){
            calculate_slider_price(val);
            show_guardian_field($(this).closest('.gfield').attr('id'), val);
          }
        });
        calculate_slider_price();
      }
    },
    'basket': {
      init: function() {
        // JavaScript to be fired on the about us page
        var paymentMethodMembership = $("dd.variation-Iwouldliketopayby").text();
        var paymentMethodDonation = $("dd.variation-Iwouldliketomakea").text();
        var paymentFrequency = $("dd.variation-IwouldlikemyDirectDebittobetaken").text();
        var appendFrequency = '/month';
        if($.trim(paymentMethodMembership.toLowerCase()) === 'direct debit' || $.trim(paymentMethodDonation.toLowerCase()) === 'regular'){
          if($.trim(paymentFrequency.toLowerCase()) !== 'monthly'){
            appendFrequency = '/year';
          }
          $("dd.variation-Iwouldliketogive p:not(:contains('"+appendFrequency+"'))").append(appendFrequency);
          $("dd.variation-Total p:not(:contains('"+appendFrequency+"'))").append(appendFrequency);
          $(".woocommerce-Price-amount:not(:contains('"+appendFrequency+"'))").append(appendFrequency);
        }
      },
      finalize: function() {
        // JavaScript to be fired on the basket page, after the init JS

        $('.donation input[name="ok-donation"]').attr({
          type: "number",
          min: "0",
          step: "0.05",
          pattern: "^\d+(?:\.\d{1,2})?$"
        });

      }
    },
    // checkout page, note the change from about-us to about_us.
    'checkout': {
      init: function() {
        // JavaScript to be fired on the checkout page

        function directDebit(){
        var paymentMethodMembership = $("dd.variation-Iwouldliketopayby").text();
        var paymentMethodDonation = $("dd.variation-Iwouldliketomakea").text();
          var paymentFrequency = $("dd.variation-IwouldlikemyDirectDebittobetaken").text();
          var appendFrequency = '/month';
          if($.trim(paymentMethodMembership.toLowerCase()) === 'direct debit' || $.trim(paymentMethodDonation.toLowerCase()) === 'regular'){
            if($.trim(paymentFrequency.toLowerCase()) !== 'monthly'){
              appendFrequency = '/year';
            }
            $("dd.variation-Iwouldliketogive p:not(:contains('"+appendFrequency+"'))").append(appendFrequency);
            $("dd.variation-Total p:not(:contains('"+appendFrequency+"'))").append(appendFrequency);
            $(".woocommerce-Price-amount:not(:contains('"+appendFrequency+"'))").append(appendFrequency);
          }
        }
        directDebit();
        $( document ).ajaxStop(function() {
          directDebit();
        });

        function checkoutRenewals(){
          if($("#ship-to-different-address-checkbox").is(":checked")){
            $("#dd-account-renewal-recipient").removeClass("hidden").addClass("show");
            $("#dd-welcome-pack-recipient").removeClass("hidden").addClass("show");
          }else{
            $("#dd-account-renewal-recipient").addClass("hidden").removeClass("show");
            $("#dd-welcome-pack-recipient").addClass("hidden").removeClass("show");
          }
          }
        checkoutRenewals();
        $("#customer_details").on("click","#ship-to-different-address-checkbox",function(){
          checkoutRenewals();
        });

        function existingMember(){
          var existingMember = $("#existing_member_field input[name=existing_member]:checked").val();
          if(existingMember === 'Yes'){
            $("#existing_membership_number_field").show();
          }else{
            $("#existing_membership_number_field").hide();
          }
        }
        existingMember();
        $("#customer_details").on("change","#existing_member_field input[name=existing_member]",function(){
          existingMember();
        });

        /*
        */
        function showMembershipField(){
          if($("dt.variation-Whoisthismembershipfor").length && $("dd.variation-Whoisthismembershipfor").length){
            if($("dt.variation-Whoisthismembershipfor").text().indexOf('membership') !== -1 && $("dd.variation-Whoisthismembershipfor").text().indexOf('gift') !== -1 ){
              $('#existing_member_field').hide();
              $('#existing_membership_number_field').hide();
            }else{
              $('#existing_member_field').show();
            }
          }
        }
        showMembershipField();

        function otherMotivation(){
          var motivation = $("#motivation").val();
          if(typeof(motivation) !== 'undefined'){
            if( $("#motivation").val().indexOf('Other') ){
              $('#motivation-other_field').hide();
            }else{
              $('#motivation-other_field').show();
            }
          }
        }

        otherMotivation();
        $("#customer_details").on("change","#motivation",function(){
          otherMotivation();
        });

        $("#use_primary_member_details").on("click",function(){
          if($(this).prop('checked')){
            $('#billing_title').val(primaryMemberDetails.billing_title).change();
            $('#billing_first_name').val(primaryMemberDetails.billing_first_name);
            $('#billing_last_name').val(primaryMemberDetails.billing_last_name);
            $('#billing_phone').val(primaryMemberDetails.billing_phone);
            $('#billing_email').val(primaryMemberDetails.billing_email);
            $('#billing_address_1').val(primaryMemberDetails.billing_address_1);
            $('#billing_address_2').val(primaryMemberDetails.billing_address_2);
            $('#billing_city').val(primaryMemberDetails.billing_address_town);
            $('#billing_state').val(primaryMemberDetails.billing_address_county);
            $('#billing_postcode').val(primaryMemberDetails.billing_address_postcode);
            $("#billing_country option:contains('"+primaryMemberDetails.billing_address_country+"')").prop("selected", true).change();
          }else{
            $('#billing_title').val("Mr").change();
            $('#billing_first_name').val('');
            $('#billing_last_name').val('');
            $('#billing_phone').val('');
            $('#billing_email').val('');
            $('#billing_address_1').val('');
            $('#billing_address_2').val('');
            $('#billing_city').val('');
            $('#billing_state').val('');
            $('#billing_postcode').val('');
            $('#billing_country').val("GB").change();
          }
        });

      },
      finalize: function() {
        // JavaScript to be fired on the checkout page, after the init JS
      }
    }
  };

  // The routing fires all common scripts, followed by the page specific scripts.
  // Add additional events for more control over timing e.g. a finalize event
  var UTIL = {
    fire: function(func, funcname, args) {
      var fire;
      var namespace = Sage;
      funcname = (funcname === undefined) ? 'init' : funcname;
      fire = func !== '';
      fire = fire && namespace[func];
      fire = fire && typeof namespace[func][funcname] === 'function';

      if (fire) {
        namespace[func][funcname](args);
      }
    },
    loadEvents: function() {
      // Fire common init JS
      UTIL.fire('common');

      // Fire page-specific init JS, and then finalize JS
      $.each(document.body.className.replace(/-/g, '_').split(/\s+/), function(i, classnm) {
        UTIL.fire(classnm);
        UTIL.fire(classnm, 'finalize');
      });

      // Fire common finalize JS
      UTIL.fire('common', 'finalize');
    }
  };

  // Load Events
  $(document).ready(UTIL.loadEvents);

})(jQuery); // Fully reference jQuery after this point.
